import React, { Component } from "react";
import { connect } from "react-redux";
import AppLoader from "../../../app-components/app-loader.jsx";
import HomepageTrendingSlots from "../components/homepage-trending-slots.jsx";
import ArticlePicker from "../components/article-picker.jsx";
import {
  fetchHomepageTrending,
  saveHomepageTrending,
  publishHomepageTrending,
  revertHomepageTrending,
  openPicker,
  closePicker,
  setItems,
  searchArticles,
  selectArticle,
  MAX_ITEMS,
} from "../homepage-trending-action.js";

class HomepageTrendingContainer extends Component {
  componentDidMount() {
    this.props.fetchHomepageTrending();
  }

  render() {
    const p = this.props;
    if (p.isLoading) return <AppLoader message="Loading Homepage Trending" />;
    return (
      <>
        <HomepageTrendingSlots
          items={p.items}
          isPublished={p.isPublished}
          publishedAt={p.publishedAt}
          dirty={p.dirty}
          isSaving={p.isSaving}
          maxItems={MAX_ITEMS}
          openPicker={p.openPicker}
          setItems={p.setItems}
          save={p.saveHomepageTrending}
          publish={p.publishHomepageTrending}
          revert={p.revertHomepageTrending}
        />
        <ArticlePicker
          open={p.picker.open}
          search={p.search}
          searchArticles={p.searchArticles}
          selectArticle={p.selectArticle}
          closePicker={p.closePicker}
          selectedIds={p.items.map((it) => it.articleId)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { items, isPublished, publishedAt, dirty, isLoading, isSaving, picker, search } = state.tool.homepageTrending;
  return { items, isPublished, publishedAt, dirty, isLoading, isSaving, picker, search };
};

const mapDispatchToProps = (dispatch) => ({
  fetchHomepageTrending: () => dispatch(fetchHomepageTrending()),
  saveHomepageTrending: () => dispatch(saveHomepageTrending()),
  publishHomepageTrending: () => dispatch(publishHomepageTrending()),
  revertHomepageTrending: () => dispatch(revertHomepageTrending()),
  openPicker: (slotIndex) => dispatch(openPicker(slotIndex)),
  closePicker: () => dispatch(closePicker()),
  setItems: (items) => dispatch(setItems(items)),
  searchArticles: (q) => dispatch(searchArticles(q)),
  selectArticle: (a) => dispatch(selectArticle(a)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomepageTrendingContainer);
